export enum CampaignGoalEnum {
    CONVERSIONS = 'Conversions',
    ENGAGEMENT = 'Engagement',
    AWARENESS = 'Brand Awareness',
}
